import BootcampPerformance from "./BootcampPerformance";
import IndividualPerformance from "./IndividualPerformance";

const Pages = {
  BootcampPerformance,
  IndividualPerformance,
};

export default Pages;
